import React from 'react';

class AlertInfo extends React.Component {
  render() {
    return (
      <div className="alert alert-info" role="alert">
        Спасибо за регистрацию!<br/><br/>
        Для попадания в основной состав нажмите кнопку <b>"Подтвердить участие"</b>. <br/>
        <i> С вопросами по турнирам обращайтесь к </i> <a className="payment-info" rel="nofollow" href="https://vk.com/sportey">Александру</a>!
      </div>
    )
  }
}

export default AlertInfo;
